export const ProfileTranslationsUk = {
  'Nickname must be unique': 'Нікнейм повинен бути унікальним',
  save: 'Зберегти',
  lastName: 'Прізвище',
  firstName: "Ім'я",
  patronymicOptional: "По батькові (необов'язково)",
  nickname: 'Нікнейм',
  phoneNumber: 'Номер телефону',
  email: 'Електронна пошта',
  verifyEmail: 'Підтвердити електронну пошту',
  newPassword: 'Новий пароль',
  confirmNewPassword: 'Підтвердіть новий пароль',
  showPassword: 'Показати пароль',
  enterNewPasswordAgain: 'Введіть новий пароль ще раз',
  saveChanges: 'Зберегти зміни',
  profilePhoto: 'Фото профілю',
  maxFileSize: 'Максимальний розмір файлу - 5 МБ',
  verify: 'Верифікувати',
  verified: 'Верифіковано',

  changeEmailMessage:
  'Повідомлення для підтвердження зміни електронної пошти відправлено на {{email}}. Будь ласка, перевірте вашу поштову скриньку та слідуйте інструкціям для підтвердження.',

  // errors validate
  fieldIsRequired: "Поле обов'язкове",
  nameLength: 'Ім’я має бути менше 64 символів',
  surnameLength: 'Прізвище має бути менше 64 символів',
  patronymicLength: 'По-батькові має бути менше 64 символів',
  latinCharacters:
    'Дозволені лише латинські літери, цифри, тире і підкреслення',
  validEmail: 'Введіть дійсну адресу електронної пошти',
  passwordMinLength: 'Пароль має бути не менше 8 символів',
  passwordMaxLength: 'Пароль має бути менше 32 символів',
  passwordRequirements:
    'Пароль повинен містити мінімум 8 латинських символів, одну велику літеру, одну цифру',
  passwordsMatch: 'Паролі повинні збігатися',

  // errors back-end
  'Email in use': 'Електронна пошта вже використовується.',
};
